/**
 * Pre-compiled localized messages for DraggableList component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import draggableListMessages_en from "./intl/en";
import draggableListMessages_de from "./intl/de";
import draggableListMessages_es from "./intl/es";
import draggableListMessages_fr from "./intl/fr-FR";
import draggableListMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const draggableListMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(draggableListMessages_en),
  de: normalizeMessages(draggableListMessages_de),
  es: normalizeMessages(draggableListMessages_es),
  "fr-FR": normalizeMessages(draggableListMessages_fr),
  "pt-BR": normalizeMessages(draggableListMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for DraggableList component
 */
export type DraggableListMessageKey = "emptyMessage" | "removeButtonLabel";
